import { motion, useReducedMotion } from 'framer-motion';

interface EqualizerBarsProps {
  /** Number of bars. */
  bars?: number;
  className?: string;
}

// A10 "Card_tile_line" from animation.md — thin bars animate height like an
// equalizer, a lightweight "processing / live" indicator. Recolored cyan,
// scales to N bars, reduced-motion aware.
export function EqualizerBars({ bars = 5, className = '' }: EqualizerBarsProps) {
  const reduce = useReducedMotion();
  const colors = ['#074EDC', '#FF8C00', '#4AAC00', '#ED0216'];
  return (
    <div className={`flex items-end gap-1 ${className}`} aria-hidden>
      {Array.from({ length: bars }).map((_, i) => (
        <motion.span
          key={i}
          className="w-1 rounded-full"
          style={{ height: 8, backgroundColor: colors[i % colors.length] }}
          animate={reduce ? undefined : { height: [8, 20 + (i % 3) * 6, 8] }}
          transition={
            reduce ? undefined : { duration: 1 + (i % 4) * 0.25, repeat: Infinity, ease: 'easeInOut', delay: i * 0.12 }
          }
        />
      ))}
    </div>
  );
}
